<template>
    <div
        v-if="currentMessageBoxData"
        class="wrapper"
    >
        <div class="mask"></div>
        <div class="dialog">
            <div class="title">
                {{ currentMessageBoxData.title }}
                <div class="date">
                    {{ $tools.formatTime(+currentMessageBoxData.sendTime, 'MM月DD日 HH:mm') }}
                </div>
            </div>
            <pc-preview
                v-if="currentMessageBoxData.announcement"
                :text="currentMessageBoxData.announcement"
            />
            <div class="button-container">
                <el-button
                    v-for="(item, index) in buttonList"
                    :key="index"
                    :disabled="disabled"
                    :class="['message-button']"
                    :type="[11, 21, 32].includes(item.actionCode) ? 'primary' : ''"
                    size="medium"
                    @click="buttonFunction(item.actionCode)"
                >
                    {{ item.title + (time > 0 ? `(${time})` : '') }}
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
import PcPreview from './PcPreview';

export default {
    name: 'XxNoticeDialog',
    components: {
        PcPreview,
    },
    data() {
        return {
            noticeList: [],
            time: 0,
            disabled: true,
            currentMessageBoxData: null,
            buttonList: [],
        };
    },
    async mounted() {
        await this.getAlert();
        if (this.noticeList && this.noticeList.length > 0) {
            this.renderMessageBox(this.noticeList.shift());
        }
    },
    methods: {
        buttonFunction(actionCode) {
            // 通知类：11- 确认，规则类：21-确认规则，22-稍后确认，函件类：31-申诉，32-签署
            if ([11, 21].includes(actionCode)) {
                this.confirm();
            } else if ([32].includes(actionCode)) {
                this.$tools.linkTo('/content/punishment/detail.html', { ticketId: this.currentMessageBoxData.callbackParams.ticketId, mode: 'edit' });
            } else {
                this.renderMessageBox(this.noticeList.shift());
            }
        },
        renderMessageBox(data) {
            /**
             * 把弹窗数据给它，当数据为空就结束了。
             */
            this.currentMessageBoxData = data;
            if (!this.currentMessageBoxData) return;
            this.time = this.currentMessageBoxData.forceDuration;
            this.disabled = true;
            this.buttonList = this.currentMessageBoxData.buttonList;
            const timer = setInterval(() => {
                this.time -= 1;
                if (this.time < 1) {
                    clearInterval(timer);
                    this.disabled = false;
                }
            }, 1000);
        },
        async getAlert() {
            const { announcementInfoList } = await this.$hPost('/api/vss/shepherd/announcement/queryVssForce', {
                paging: {
                    offset: 0,
                    limit: 3,
                },
            });
            this.noticeList = announcementInfoList || [];
        },
        async confirm() {
            if (this.disabled) return;
            try {
                await this.$hPost('/api/vss/shepherd/announcement/detail', {
                    id: this.currentMessageBoxData.id,
                    userEnsure: true,
                });
                this.renderMessageBox(this.noticeList.shift());
            } catch {
                this.$message.error('网络异常');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.message-button:not(:first-child) {
    margin-left: 20px;
}
.mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1000;
    opacity: 0.7;
    background: #000000;
}
.dialog {
    position: fixed;
    width: 70%;
    max-width: 1000px;
    min-width: 620px;
    max-height: 600px;
    overflow-y: auto;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -70%, 0);
    background: #fff;
    z-index: 1001;
    padding: 40px 30px 30px 30px;
    box-shadow: 0px 0px 13px 4px #0000004d;
    border-radius: 8px;
    .title {
        font-size: 20px;
        color: #ef5f5f;
        text-align: center;
        padding: 20px;
        word-wrap: break-word;
        word-break: break-all;
        .date {
            font-size: 12px;
            text-align: center;
            color: #a2a4b3;
            margin-top: 10px;
        }
    }
    .announcement {
        padding: 0 30px;
        line-height: 30px;
        word-wrap: break-word;
        word-break: break-all;
    }
    .button-container {
        text-align: center;
        margin-top: 30px;
    }
    .confirm {
        width: 150px;
        height: 36px;
        line-height: 36px;
        background: #15cdb0;
        border-radius: 2px;
        font-size: 14px;
        color: #ffffff;
        border: none;
        outline: none;
        cursor: pointer;
        &.disabled {
            background: #a2a4b3;
        }
    }
    /deep/ .quillWrapper .ql-snow.ql-toolbar {
        display: none;
    }
    .ql-container.ql-snow {
        border: 0px;
    }
}
</style>
